import { Injectable } from "@angular/core";
import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { MarkupCriteria } from "../model/core/MarkupCriteria";

export const CHANNEL_MARKUP: string = "MarkupChannel";

export interface IMarkupService {
  retrieveMarkupForCriteria(
    criteria: MarkupCriteria,
  ): Promise<CubiqTS.MarkupInfoImpl | CubiqTS.ErrorsImpl>;
}
